import * as React from 'react';
import styled from 'styled-components';
import { FolderClosed } from 'ui/icons/action/FolderClosed';
import { fontWeights, spacing } from 'ui/theme';
import { DeletableItem, DeletableItemDisplayText } from '../types';
import { getItemsDeletionVerb, getItemsTypeName } from '../utils';

type SingularDeletionPromptProps = {
  content: DeletableItem[];
  folders: DeletableItem[];
  displayTextForContentItems: DeletableItemDisplayText;
  warning?: React.ReactNode;
};

const PromptContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};

  svg {
    vertical-align: bottom;
    margin-right: ${spacing.quarter};
  }
`;

const BoldText = styled.b`
  font-weight: ${fontWeights.bold};
`;

export const SingularDeletionPrompt = ({
  content,
  folders,
  displayTextForContentItems,
  warning,
}: SingularDeletionPromptProps) => {
  const deletionVerb = getItemsDeletionVerb(content, folders, displayTextForContentItems);
  const itemTypeName = getItemsTypeName(content, folders, displayTextForContentItems);

  const { name } = content[0] || folders[0];

  return (
    <PromptContainer>
      <p>
        Are you sure that you want to {deletionVerb} the{' '}
        <BoldText>
          {!!folders.length && <FolderClosed />}
          {name}
        </BoldText>{' '}
        {itemTypeName}?
      </p>
      {displayTextForContentItems.suffixText && <p>{displayTextForContentItems.suffixText}</p>}
      {warning}
    </PromptContainer>
  );
};
